import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AllTenantsState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  tenants: string[] | null
}

const initialState: AllTenantsState = {
  isLoading: false,
  error: null,
  httpStatus: null,
  tenants: []
}

export const getAllTenantsSlice = createSlice({
  name: 'tenants',
  initialState,
  reducers: {
    allTenantsLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        tenants: null
      }
    },
    allTenantsUpdateAction: (state, action: PayloadAction<{ data: string[], httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        tenants: action.payload.data
      }
    },
    allTenantsErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        tenants: null
      }
    }
  }
})

export const {
  allTenantsLoadingAction,
  allTenantsUpdateAction,
  allTenantsErrorAction
} = getAllTenantsSlice.actions

export default getAllTenantsSlice.reducer
